export default [
    {
        path: '/questionarios',
        view: 'questionarios/Index',
        name: 'Questionários',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questionários',
                disabled: true,
                exact: true,
                to: '/questionarios',
            },
        ],
    },
    {
        path: '/questionarios/novo',
        view: 'questionarios/New',
        name: 'Cadastrar Questionário',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questionários',
                disabled: false,
                exact: true,
                to: '/questionarios',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/questionarios/novo',
            }
        ],
    },
    {
        path: '/questionarios/editar/:id',
        view: 'questionarios/Edit',
        name: 'Edição de Questionário',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questionários',
                disabled: false,
                exact: true,
                to: '/questionarios',
            },
            {
                text: 'Edição',
                disabled: true,
                exact: true,
                to: '/questionarios/editar/:id',
            }
        ],
    },
    {
        path: '/questionarios/visualizar/:id',
        view: 'questionarios/View',
        name: 'Visualização de Questionário',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questionários',
                disabled: false,
                exact: true,
                to: '/questionarios',
            },
            {
                text: 'Visualização',
                disabled: true,
                exact: true,
                to: '/questionarios/visualizar/:id',
            }
        ],
    },
    {
        path: '/questionarios/vincularQuestoes/:id',
        view: 'questionarios/VincularQuestoes',
        name: 'Vincular Questões de Questionário',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questionários',
                disabled: false,
                exact: true,
                to: '/questionarios',
            },
            {
                text: 'Vincular Questões',
                disabled: true,
                exact: true,
                to: '/questionarios/vincularQuestoes/:id',
            }
        ],
    },
    {
        path: '/questionarios/excluir',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
    {
        path: '/questionarios/ativarInativar',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
    {
        path: '/questionarios/adicionarQuestao',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
    {
        path: '/questionarios/excluirQuestao',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
];
